var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-box"},[_c('div',{staticClass:"main-box-div main-box-leftTop"}),_c('div',{staticClass:"main-box-div main-box-rightBottom"}),_c('div',{staticClass:"main-box-div main-box-leftBottom"}),_c('div',{staticClass:"main-box-div main-box-rightTop"}),_c('div',{staticClass:"div-border"}),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }